export const DELETED_STATUS = 0;
export const NEEDS_CORRECTIONS_STATUS = 5;
export const SUBMITTED_STATUS = 10;
export const AWAITING_REVIEW_STATUS = 20;
export const UNDER_REFEREE_STATUS = 30;
export const REFUSED_STATUS = 40;
export const PUBLISHED_STATUS = 50;

const allStatus = {
  [DELETED_STATUS]: "Deleted",
  [NEEDS_CORRECTIONS_STATUS]: "Needs Corrections",
  [SUBMITTED_STATUS]: "Submitted",
  [AWAITING_REVIEW_STATUS]: "Awaiting Review",
  [UNDER_REFEREE_STATUS]: "Reviewed",
  [REFUSED_STATUS]: "Refused",
  [PUBLISHED_STATUS]: "Published",
};

export const status = {
  god: [
    DELETED_STATUS,
    NEEDS_CORRECTIONS_STATUS,
    SUBMITTED_STATUS,
    AWAITING_REVIEW_STATUS,
    UNDER_REFEREE_STATUS,
    REFUSED_STATUS,
    PUBLISHED_STATUS,
  ].reduce((obj, cur) => {
    return { ...obj, [cur]: allStatus[cur] };
  }, {}),
  admin: [
    NEEDS_CORRECTIONS_STATUS,
    SUBMITTED_STATUS,
    AWAITING_REVIEW_STATUS,
    UNDER_REFEREE_STATUS,
    REFUSED_STATUS,
    PUBLISHED_STATUS,
  ].reduce((obj, cur) => {
    return { ...obj, [cur]: allStatus[cur] };
  }, {}),
  reviewer: [AWAITING_REVIEW_STATUS, UNDER_REFEREE_STATUS].reduce(
    (obj, cur) => {
      return { ...obj, [cur]: allStatus[cur] };
    },
    {}
  ),
  author: [
    NEEDS_CORRECTIONS_STATUS,
    SUBMITTED_STATUS,
    AWAITING_REVIEW_STATUS,
    UNDER_REFEREE_STATUS,
    REFUSED_STATUS,
    PUBLISHED_STATUS,
  ].reduce((obj, cur) => {
    return { ...obj, [cur]: allStatus[cur] };
  }, {}),
};

export const articleDAO = function (input = {}) {
  return {
    title: input.title || "",
    term: input.term_org || "",
    author: `${input.author_surname}, ${input.author_name}` || "",
    status: allStatus[`${input.status}`] || "",
    date: input.updated_at.split(" ")[0] || "",
    viewLink: `/article/${input.id}` || "",
    reviewLink: `/article/${input.id}/review` || "",
    editLink: `/article/${input.id}/edit` || "",
  };
};

export const reviewDAO = function (input = {}) {
  return {
    text: input.text || "",
    approved: input.approved || 0,
    corrections: input.corrections || 1,
    article_id: input.article_id || 0,
    user_id: input.user_id || 0,
  };
};



// WEBPACK FOOTER //
// ./src/components/helpers.js